// Copyright (c) 2024 - Present. Hardfin, Inc. All rights reserved.
// Hardfin Confidential - Restricted

/**
 * Returns an absolute URL to create a new location.
 *
 * @param name - The name of the new location.
 */
export function getNewLocationURL(name: string) {
  const url = new URL('/locations', document.location.origin);

  url.searchParams.append('new', encodeURIComponent(name));

  return url;
}
